export default __webpack_public_path__ + "static/media/Head_4_Ear_1_C5.e8ca2a13.svg";